/* eslint-disable import/prefer-default-export */

export const ID_COOKIE_MAX_AGE_DAYS = 7;
